import repository from '@/repositories/repository'
import url from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/ramo-atividade`

    return {
        index(queryParms) {
            return repository.get(`${baseUrl}?${url.serialize(queryParms)}`)
        },
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        show(id) {
            return repository.get(`${baseUrl}/${id}`)
        },
        edit(id) {
            return repository.get(`${baseUrl}/${id}/edit`)
        },
        update(params, id) {
            return repository.put(`${baseUrl}/${id}`, params)
        },
        destroy(id) {
            return repository.delete(`${baseUrl}/${id}`)
        },
        datatable(queryParms = {}) {
            return repository.get(`${baseUrl}/datatable?${url.serialize(queryParms)}`)
        },
    }
}